import React from 'react';

const GetInTouch = () => {
    return(
        <div className="row mt_50 mb_50 justify-content-center" >
            <div className="col-lg-8 text-center border border-secondary p-4">
                <h4 className="t_color3 wow fadeInUp hemdahl-text-dark hemdahl-text-md" data-wow-delay="0.2s">Ready to get started?</h4>
                <a className="btn_get btn_hover new_btn mt-2" href="./contact">GET IN TOUCH</a>
            </div>
        </div>
    )
}
export default GetInTouch;
